import React from "react";
import Title from "@airasia/phoenix-components/components/Title";
import Text from "@airasia/phoenix-components/components/Text";


function IntroTextWrapper({ introData }) {
  return (
      <div>
      <Title
        accessible
        inverted={false}
        textAlign="left"
        theme="AIRASIA_CLASSIC"
        type="h1"
        color="primary"
      >
        {introData.title}
      </Title>
      <Text
        accessible
        display="inlineFlex"
        hasToggle={false}
        opacity={1}
        tag="p"
        theme="AIRASIA_CLASSIC"
        translation={{}}
        type="default"
      >
        {introData.text}
      </Text>
      <br /><br /><br />
      <Title
        accessible
        inverted={false}
        textAlign="left"
        theme="AIRASIA_CLASSIC"
        type="h2"
        color="primary"
      >
        {introData.subtitle}
      </Title>
      <Text
        accessible
        display="inlineFlex"
        hasToggle={false}
        opacity={1}
        tag="p"
        theme="AIRASIA_CLASSIC"
        translation={{}}
        type="default"
      >
        {introData.subtext}
      </Text>
      <br /><br /><br />
      <Title
        accessible
        inverted={false}
        textAlign="left"
        theme="AIRASIA_CLASSIC"
        type="h2"
        color="primary"
      >
        {introData.subtitle_carousel}
      </Title>
     </div>
    );
  }

export default IntroTextWrapper;